// src/pages/MapPage.jsx
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import "../styles/map-page.css";

const categories = [
  { id: "esotericism", label: "Esotericism" },
  { id: "cybernetics", label: "Cybernetics" },
  { id: "politics", label: "Politics" },
  { id: "medieval", label: "Medieval" },
  { id: "literature", label: "Literature" },
  { id: "music", label: "Music" },
  { id: "projects", label: "Projects" },
];

const dialogueLines = [
  "You grabbed my hand and we fell into it",
  "Like a daydream",
  "or a fever"
];

const MapPage = () => {
  const [dialogueIndex, setDialogueIndex] = useState(0);
  const [dialogueText, setDialogueText] = useState("");
  const [dialoguePhase, setDialoguePhase] = useState("waiting");
  const [showCursor, setShowCursor] = useState(true);


  const points = categories.map((cat, i) => {
    const angle = (i / categories.length) * 2 * Math.PI - Math.PI / 2;
    const x = 50 + 40 * Math.cos(angle);
    const y = 50 + 40 * Math.sin(angle);

    return {
      ...cat,
      x,
      y,
    };
  });

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (!dialogueLines.length) return;

    const currentLine = dialogueLines[dialogueIndex];
    let timeout = null;

    if (dialoguePhase === "waiting") {
      timeout = window.setTimeout(() => setDialoguePhase("typing"), 400);
    } else if (dialoguePhase === "typing") {
      if (dialogueText.length < currentLine.length) {
        timeout = window.setTimeout(() => {
          setDialogueText(currentLine.slice(0, dialogueText.length + 1));
        }, 40);
      } else {
        timeout = window.setTimeout(() => setDialoguePhase("pausing"), 1200);
      }
    } else if (dialoguePhase === "pausing") {
      timeout = window.setTimeout(() => setDialoguePhase("deleting"), 900);
    } else if (dialoguePhase === "deleting") {
      if (dialogueText.length > 0) {
        timeout = window.setTimeout(() => {
          setDialogueText(currentLine.slice(0, dialogueText.length - 1));
        }, 25);
      } else {
        setDialogueIndex((idx) => (idx + 1) % dialogueLines.length);
        setDialoguePhase("waiting");
      }
    }

    return () => window.clearTimeout(timeout);
  }, [dialogueIndex, dialoguePhase, dialogueText]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    const interval = window.setInterval(() => {
      setShowCursor((value) => !value);
    }, 500);
    return () => window.clearInterval(interval);
  }, []);

  return (
    <div className="map-page">
      <div className="cyber-bg" />
      <div className="scanlines" />
      <div className="circuit-overlay" />
      
        <div className="map-video-bg">
          <video autoPlay muted loop playsInline>
            <source src="/images/lain.mp4" type="video/mp4" />
          </video>
        </div>

      <div className="map-page__header">
        <span className="map-page__eyebrow">System Navigation</span>
        <h1>A Body Without Organs</h1>
        {/* <p>Select a domain or explore the intersections between them.</p> */}
      </div>

      <div className="map-container">
        <div className="cyber-dialogue-box">
          <div className="cyber-dialogue-box__header">
            <span className="cyber-dialogue-box__label">TRANSMISSION</span>
            <span className="cyber-dialogue-box__status">LIVE</span>
          </div>

          <div className="cyber-dialogue-box__body">
            <p>
              {dialogueText}
              <span className={showCursor ? "cyber-typing-cursor" : ""}>█</span>
            </p>
          </div>
        </div>
        <div className="hud-window hud-window--left">
          <span>NODE SIGNAL: STABLE</span>
        </div>

        <div className="hud-window hud-window--right">
          <span>REALITY INDEX: 07</span>
        </div>
        <div className="heptagon">
          <svg
            className="heptagon__lines"
            viewBox="0 0 100 100"
            preserveAspectRatio="none"
          >
            {points.flatMap((point, i) =>
              points.slice(i + 1).map((target, j) => (
                <line
                  key={`${i}-${j}`}
                  x1={point.x}
                  y1={point.y}
                  x2={target.x}
                  y2={target.y}
                  className="heptagon__line"
                />
              ))
            )}
          </svg>

          <div className="heptagon__center" />

          {points.map((point) => (
            <Link
              key={point.id}
              to={`/category/${point.id}`}
              className="heptagon__node"
              style={{ left: `${point.x}%`, top: `${point.y}%` }}
            >
              {point.label}
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MapPage;